export class EditableObject {

    constructor(params) {
        if (!params) {
            this.id = undefined;
            this.title = undefined;
            this.description = undefined;
            this.imagelink = undefined;
            this.price = undefined;
            this.currency = undefined;
            this.url = undefined;
            this.site = undefined;
            this.idList = undefined;
            this.datecreation = undefined;
            this.affiliateLink = undefined;
            this.reservationid = undefined;
        } else {
            const {
                id = undefined,
                title = undefined,
                description = undefined,
                imagelink = undefined,
                price = undefined,
                currency = undefined,
                url = undefined,
                site = undefined,
                idList = undefined,
                datecreation = undefined,
                affiliateLink = undefined,
                reservationid = undefined
            } = params;
            this.id = id;
            this.title = title;
            this.description = description;
            this.imagelink = imagelink;
            this.price = price;
            this.currency = currency;
            this.url = url;
            this.site = site;
            this.idList = idList;
            this.datecreation = datecreation;
            this.affiliateLink = affiliateLink;
            this.reservationid = reservationid;
        }
    }

    static fromImportedObject(imported) {
        return new EditableObject({
            title: imported.title || imported.shortTitle,
            description: imported.description,
            imagelink: imported.image,
            price: imported.price,
            currency: imported.currency || "",
            url: imported.url,
            site: imported.site,
        });
    }

    static fromDBObject(dbObject) {
        return new EditableObject({
            id: dbObject.id,
            title: dbObject.objectname,
            description: dbObject.description,
            imagelink: dbObject.imagelink,
            price: dbObject.price,
            currency: dbObject.currency || "",
            url: dbObject.urllink,
            site: dbObject.storeName,
            idList: dbObject.idList,
            datecreation: dbObject.datecreation,
            affiliateLink: dbObject.affiliateLink,
            reservationid: dbObject.reservationid
        });
    }

    isValid() {
        return this.title || this.url;
    }
}
